import http from '@/services/http';
import { SearchReq } from '@/type/pages';
import { filterEmpty } from '@/utils/dataFormat';
import { error } from '@/utils/safetyLog';

export const getSearch = async (request: SearchReq) => {
  try {
    const requestData = filterEmpty({
      contentType: 'blog_article_page,blog_wiki_article_page',
      ...request,
      includeReference: ['blog_snippet.category'],
    });
    const response = await http({}).post('/search', requestData);
    return response;
  } catch (e) {
    error('get search error:', e);
    return null;
  }
};
